export function StaticDataState(props: {
  title: string;
  message?: string;
  error?: boolean;
  onRetry?: () => void;
}) {
  return (
    <section className="panel stack-md data-state" role={props.error ? "alert" : "status"} aria-live="polite">
      <div className="section-heading">
        <p className="eyebrow">Layup List</p>
        <h1>{props.title}</h1>
      </div>
      {props.message ? <p className="auth-copy">{props.message}</p> : null}
      {props.onRetry ? (
        <button type="button" className="secondary-link data-retry" onClick={props.onRetry}>
          Try again
        </button>
      ) : null}
    </section>
  );
}
